import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import en from 'date-fns/locale/en-GB';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import dayjs from '@/js/libs/dayjs/index.ts';
import { DATE_FORMAT } from './constants.js';
import DatePickerInput from './DatePickerInput.js';
import { getDateTime, isValid } from './helpers.js';
const DatePicker = ({ selected = null, dateFormat = DATE_FORMAT, placeholder = '', value, onChange, showLocal = false, startOfDay = false, dataTestId, timeFormat, onBlur, getRef, isClearable, autoComplete = 'none', ...props }) => {
    const LOCALE = 'en';
    registerLocale(LOCALE, en);
    const selectedDate = React.useMemo(() => {
        if (!value)
            return selected;
        const date = dayjs(value, dateFormat);
        if (isValid(date)) {
            return getDateTime(value, dateFormat, showLocal, startOfDay);
        }
        return selected;
    }, [value, selected, dateFormat, showLocal, startOfDay]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const handleClearClick = React.useCallback((event) => {
        onChange(null, event);
    }, [onChange]);
    return (_jsx("div", { "data-testid": 'datepicker-div', children: _jsx(ReactDatePicker, { customInput: _jsx(DatePickerInput, { dataTestId: dataTestId, isClearable: isClearable, onClearClick: handleClearClick, dateSelected: !!selectedDate }), locale: LOCALE, ref: getRef, onChange: onChange, onBlur: onBlur, placeholderText: placeholder, value: dayjs.isDayjs(value) ? value.format(DATE_FORMAT) : value, timeFormat: timeFormat, dateFormat: dateFormat, selected: selectedDate, strictParsing: true, autoComplete: autoComplete, ...props }) }));
};
export { DatePicker };
